import React, { useEffect, useState } from 'react';
import { SwitchWrapper, SwitchLabel, SwitchSlider } from './style';

export interface SwitchProps {
  defaultValue?: boolean;
  disabled?: boolean;
  onChangeValue?: (value: boolean) => void;
}

const Switch = ({ defaultValue, disabled, onChangeValue }: SwitchProps) => {
  const [currentValue, setCurrentValue] = useState(false);

  useEffect(() => {
    setCurrentValue(defaultValue || false);
  }, [defaultValue]);

  return (
    <SwitchWrapper className={disabled ? 'disabled' : ''}>
      <SwitchLabel>
        <input
          type="checkbox"
          checked={currentValue}
          disabled={disabled}
          onChange={(e) => {
            setCurrentValue(e.target.checked);
            if (onChangeValue) onChangeValue(e.target.checked);
          }}
        />
        <SwitchSlider />
      </SwitchLabel>
    </SwitchWrapper>
  );
};

export default Switch;
